// theme.js
import { createTheme, Switch } from "@mantine/core";

// The toggle: a pill with a thumb that fills it, inset 2px and flush with the
// end it travels to — Mantine's stock thumb is small enough against its track
// to read as a dot floating in the middle. Width, height and thumb are kept as
// a set per size rather than nudging one of them, since the track-label
// padding Mantine positions the thumb with is derived from the gap between
// height and thumb.
const SWITCH_SIZES = {
  xs: { height: 18, width: 32, thumb: 14 },
  sm: { height: 22, width: 40, thumb: 18 },
  md: { height: 26, width: 46, thumb: 22 },
  lg: { height: 30, width: 54, thumb: 26 },
  xl: { height: 36, width: 64, thumb: 32 },
};

export const theme = createTheme({
  colors: {
    // 10 shades from light (0) to dark (9)
    brand: [
      "#F8E3DB", // 0 - very light
      "#F0C6B5", // 1
      "#E7A58B", // 2
      "#DE8662", // 3
      "#D76C41", // 4
      "#D0521F", // 5 ← your main color
      "#B9491C", // 6
      "#953B16", // 7
      "#722D11", // 8
      "#4F1F0C", // 9 - very dark
    ],
  },
  primaryColor: "brand", // use this palette as primary
  primaryShade: 5, // index in the brand array (matches #d0521f)

  components: {
    Switch: Switch.extend({
      // Mantine punches a dot the colour of the track into the middle of the
      // thumb by default. The thumb is solid white here.
      defaultProps: { withThumbIndicator: false },

      vars: (_theme, { size }) => {
        // A numeric or custom size is Mantine's to resolve; only the named
        // sizes are ours to re-cut.
        const cut = SWITCH_SIZES[size ?? "sm"];
        if (!cut) {
          return { root: {} };
        }

        return {
          root: {
            "--switch-height": `${cut.height}px`,
            "--switch-width": `${cut.width}px`,
            "--switch-thumb-size": `${cut.thumb}px`,
            "--switch-track-label-padding": `${(cut.height - cut.thumb) / 2}px`,
          },
        };
      },
    }),
  },
});
